// GAVION search-accents (100_): the list search boxes (Leads, Contacts, Deals, Users) ignore accents and case. Each
// searched view has a computed field public.search_text(<row>) — its searched columns through search_unaccent and
// lower(); the query goes the same way here and is sent as one filter search_text=ilike.*q*.
import type { GetListParams } from "ra-core";
import { cleanPostgrestSearch } from "../companies/companyCreate";

/** The JS twin of lower(search_unaccent(q)) (08_): « Hélène Côté » → « helene cote », œ → oe, æ → ae. */
export const searchKey = (q: string) =>
  q
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/œ/gi, "oe")
    .replace(/æ/gi, "ae")
    .replace(/ß/g, "ss")
    .toLowerCase();

/** filter.q → filter["search_text@ilike"]; a blank (or syntax-only) query leaves no search filter. */
export const applyAccentSearch = (params: GetListParams): GetListParams => {
  if (!params.filter?.q) return params;
  const { q: rawQ, ...filter } = params.filter;
  // GAVION company-create: no PostgREST syntax character in the value; nothing left = no search filter
  const q = cleanPostgrestSearch(searchKey(String(rawQ)));
  if (!q) return { ...params, filter };
  return { ...params, filter: { ...filter, "search_text@ilike": q } };
};
